import * as React from 'react';
import { Box } from '@chakra-ui/react';
import { LayoutMainProps } from './model';

export const MAIN_CONTENT_ID = 'main-content';

export const LayoutMain: React.FC<LayoutMainProps> = ({
	children,
	disablePadding,
	background,
	inset,
	p,
	asMain = true,
	id,
	tabIndex,
	...rest
}) => {
	const resolvedId = id ?? (asMain ? MAIN_CONTENT_ID : undefined);
	const resolvedTabIndex = tabIndex ?? (asMain ? 0 : undefined);

	return (
		<Box
			{...rest}
			as={asMain ? 'main' : 'div'}
			id={resolvedId}
			tabIndex={resolvedTabIndex}
			order={2}
			p={disablePadding ? 0 : p}
			background={inset ? 'chakra-subtle-bg' : background}
			shadow={inset ? 'inner' : 'xs'}
			flexGrow={1}
			flexShrink={1}
			overflow="auto"
		>
			{children}
		</Box>
	);
};

/**

 * Sitecore UI LayoutMain components display names

 */

LayoutMain.displayName = 'LayoutMain';
